export default {
    "sameProductAndLastReturned": "Cùng SP + Return",
    "sameProductCombo": "Cùng Combo",
    "sameProductGroupAndLowerPrice": "Cùng NSP + Giá trị thấp hơn",
}
